import CounterLink from 'components/Nav/subcomponents/CounterLink'
import SecurityLink from 'components/Nav/subcomponents/SecurityLink'
import MarketplaceToolsLink from 'components/Nav/subcomponents/MarketplaceToolsLink'

export default {
  recommendations: {
    component: CounterLink,
    native: true,
    props: { as: 'div', counter: 'summary' },
  },
  'recommendations/audits': {
    component: CounterLink,
    props: { counter: 'audit' },
  },
  'recommendations/benchmarks': {
    component: CounterLink,
    props: { counter: 'benchmark' },
  },
  'recommendations/campaigns': {
    component: CounterLink,
    props: { counter: 'recommendation' },
  },
  'user/security': {
    component: SecurityLink,
  },
  'marketplace-tools/list': {
    component: MarketplaceToolsLink,
  },
}
